export const SUPPORTED_LANGS = ["en", "ko", "zh", "ja"];

export const NAV_TABS = [
  "company",
  "product",
  "technology",
  "team",
  "partners",
  "contact",
];

export const isSupportedLang = (code) => SUPPORTED_LANGS.includes(code);

export const isNavTab = (segment) => NAV_TABS.includes(segment);
